/**
 * Plattformweite Einstellungen (`platform_settings`) — heute genau eine:
 * der Absender der Systemmails.
 *
 * **Warum nicht mehr ENV.** Passwort-Reset und Adress-Bestaetigung liefen
 * bisher ueber `SYSTEM_MAIL_*` aus `/etc/tickethub/env`. Ein Providerwechsel
 * hiess damit: Datei bearbeiten (root), drei Dienste neu starten. Die
 * Einstellung gehoert aber dem Betreiber, nicht dem Deployment — deshalb steht
 * sie in der Datenbank und ENV bleibt nur noch Fallback (ADR 0014).
 *
 * **Seit ADR 0017 steht hier kein Schluessel mehr.** Die Systemmail zeigt auf
 * eine `mail_provider`-Verbindung aus dem Vault; hier bleiben nur die beiden
 * Angaben, die *dieser Verwendung* gehoeren: Absenderadresse und -name.
 *
 * `source` sagt der Oberflaeche, ob sie gerade die Datenbank oder noch den
 * ENV-Fallback anzeigt — ohne diese Angabe waere „nichts eingetragen" von
 * „steht in `/etc/tickethub/env`" nicht zu unterscheiden.
 */
import { z } from 'zod';
import { emailSchema, uuidSchema } from './common.js';
import { outboundMailProviderSchema } from './email.js';
/** Schluessel einer Zeile in `platform_settings`. Bisher gibt es genau einen. */
export const PLATFORM_SETTING_KEYS = ['system_mail'];
export const platformSettingKeySchema = z.enum(PLATFORM_SETTING_KEYS);
/**
 * Gespeicherte Fassung — und zugleich die Eingabe: es gibt nichts zu
 * verbergen, seit die Zugangsdaten in der Verbindung liegen.
 *
 * `connection_id` ist `null`, solange der Betreiber keine Verbindung gewaehlt
 * hat; dann gilt weiterhin der ENV-Fallback.
 */
export const systemMailConfigSchema = z.object({
    connection_id: uuidSchema.nullable().default(null),
    from_address: emailSchema,
    from_name: z.string().min(1).max(200),
});
export const systemMailConfigInputSchema = systemMailConfigSchema;
/** Woher die geltende Konfiguration stammt. */
export const SYSTEM_MAIL_SOURCES = ['db', 'env'];
export const systemMailSourceSchema = z.enum(SYSTEM_MAIL_SOURCES);
/**
 * Ausgabe: dazu die Herkunft und — abgeleitet aus der Verbindung — welcher
 * Provider gerade verschicken wuerde. Der Name der Verbindung steht daneben,
 * damit die Seite ihn ohne zweiten Aufruf anzeigen kann.
 */
export const systemMailConfigPublicSchema = systemMailConfigSchema.extend({
    connection_name: z.string().nullable(),
    provider: outboundMailProviderSchema,
    source: systemMailSourceSchema,
});
/** Antwort der Testmail-Route — `ok` ist immer `true`, Fehler werden geworfen. */
export const systemMailTestResultSchema = z.object({
    ok: z.literal(true),
    to: emailSchema,
    provider: outboundMailProviderSchema,
});
//# sourceMappingURL=platform.js.map